import React, { useState,useEffect } from 'react';
import BlogDetailsArticle from 'components/blogDetails/blogDetailsArticle';
import BlogDetailsHeader from 'components/blogDetails/header';
import BlogsData from 'data/blogs/blogItem.json';
import MetaTags from 'components/base/metaTags';
import 'assets/styles/blogs.css'

const  BlogDetails =()=>{
    const [blog, setBlog] = useState({})
    useEffect(()=>{
        window.scrollTo(0, 0);
        let pathname = window.location.pathname
        let id = pathname.split('/')
        setBlog(BlogsData.find(b=>b.id === id[3]));
    },[blog])
    const metaTags={
        webTitle:'STELLS | '+blog.title,
        webSiteName:"STELLS Space Corp.",
        webImage: '/'+blog.src,
        webDescription:blog.content,
        webUrl:window.location.href,
        locale:"en_US",
        type:"article"
    }

    return (
        <div>
            <MetaTags tag={metaTags}/>
            <BlogDetailsHeader blog={blog}/>
            <BlogDetailsArticle blog={blog}/>
        </div>
    );
}

export default BlogDetails;